import { Trans } from '@lingui/macro'
import cx from 'classnames'
import * as React from 'react'

import styles from './Coupon.module.scss'
import CouponForm from './CouponForm'
import DropdownIcon from '../../core/DropdownIcon'
import Button from '../../input/Button'
import Icon from '../../media/Icon'
import overridable from '../../utils/overridable'

export const Coupon = () => {
    const [isOpen, setOpen] = React.useState(false)

    return (
        <>
            <Button
                variant="link"
                onClick={() => setOpen(!isOpen)}
                className={cx(styles.toggle, { [styles.open]: isOpen })}
                name="Coupon code toggle"
                category="checkout.coupon.toggle"
            >
                <Trans id="checkout.coupon.toggle">Got a promotion code?</Trans>{' '}
                <Icon
                    component={DropdownIcon}
                    title=""
                    className={styles.toggleIcon}
                />
            </Button>

            {isOpen && <CouponForm />}
        </>
    )
}

export default overridable('CheckoutCoupon')(Coupon)
